import { createTheme, Divider, Typography } from "@mui/material";
import { Box, ThemeProvider } from "@mui/system";
import { useEffect } from "react";
import { pdfjs } from "react-pdf";
import { useDispatch, useSelector } from "react-redux";
import { HashRouter, Route, Routes } from "react-router-dom";
import { bindActionCreators } from "redux";
import "./App.css";
import { CustomAppBar } from "./components/CustomAppBar/CustomAppBar";
import { AboutPage } from "./layout/aboutPage";
import { ActivitiesPreviewer } from "./layout/activitiesPreviewer";
import { ActivityVisualizer } from "./layout/activityVisualizer";
import { actionCreators, RootState } from "./state";
import { ActivityType } from "./types/activityType";
import { RetryOnError } from "./utils/utils";
// import { ActivityVisualizer } from "./layout/activityVisualizer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#feb647",
        },
        secondary: {
            main: "#0066ff",
        },
    },
});

function App() {
    const dispatch = useDispatch();
    const activities = useSelector((state: RootState) => state.activities.array);
    const { addActivities, setActivities } = bindActionCreators(actionCreators, dispatch);

    useEffect(() => {
        fetchActivities();
    }, []);

    const fetchActivities = () => {
        // header("Access-Control-Allow-Origin: https://www.stemabile.it");
        // console.log(process.env);
        fetch(`${process.env.REACT_APP_SERVER_URL}/server/activitiesServer.php`)
            .then((res) => {
                try {
                    return res.json();
                } catch (err) {
                    console.error(err);
                }
            })
            .then((result) => {
                setActivities(result.data as ActivityType[]);
            })
            .catch((err) => {
                console.error(`failed receiving data from server ${err}`);
                setTimeout(() => {
                    fetchActivities();
                }, 5000);
            });
    };

    useEffect(() => {
        if (activities.length > 0) return;
        RetryOnError(fetchActivities, 5000);
    }, []);

    return (
        <ThemeProvider theme={theme}>
            {/* TODO: test this <HashRouter></HashRouter> */}
            <HashRouter>
                <CustomAppBar marginTop={6}>
                    <Routes>
                        <Route path="/activity/:id" element={<ActivityVisualizer />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route
                            path="/"
                            element={
                                <>
                                    <Box padding={{ xs: 1, sm: 2 }}>
                                        <Typography variant="h2" align="center" margin={{ xs: 1 }}>
                                            STEAMabile /sti·mà·bi·le/
                                        </Typography>
                                        <Typography variant="body1" color="text.primary">
                                            <b>STEAM</b>, acronimo di <b>S</b>cience, <b>T</b>echnology, <b>E</b>
                                            ngineering, <b>A</b>rt and <b>M</b>athematics, è un metodo di apprendimento
                                            interdisciplinare sviluppato dal 2006 negli Stati Uniti con l’obiettivo di
                                            avvicinare gli studenti alle discipline matematiche e scientifiche. STEAM è
                                            progettato per integrare tutte le materie tra loro per un modo di insegnare
                                            attraverso le discipline. Questi programmi mirano a insegnare agli studenti
                                            l'innovazione, a pensare in modo critico e utilizzare l'ingegneria o la
                                            tecnologia in progetti fantasiosi o approcci creativi ai problemi del mondo
                                            reale inquadrati negli studi sociali. I programmi STEAM aggiungono arte
                                            attingendo a principi di ragionamento, etica e design e incoraggiando
                                            soluzioni creative. Contemporaneamente entrano in gioco capacità
                                            intellettive e riflessive, manuali e creative, stimolando il confronto con
                                            gli altri e sviluppando lo spirito critico, competenze indispensabili per un
                                            inserimento attivo nella società attuale. <br />
                                            Alcune attività dello Steam, forse anche tutte, consentono di progettare
                                            l’inclusione ponendosi dal punto di vista di tutti,il sistema diviene
                                            inclusivo. A prescindere dalle diagnosi e dalle difficoltà specifiche la
                                            vera classe è inclusiva in ogni caso. Per questo è necessario proporre
                                            metodologie didattiche che possono realmente includere tutti, declinandola
                                            in unica attività. Ricordiamo: l’apprendimento cooperativo; l’uso di nuove
                                            tecnologie; il coding; la robotica.
                                        </Typography>
                                    </Box>
                                    <Box marginX={{ xs: 2 }}>
                                        <Divider />
                                    </Box>
                                    <ActivitiesPreviewer />
                                </>
                            }
                        />
                    </Routes>
                </CustomAppBar>
            </HashRouter>
        </ThemeProvider>
    );
}

export default App;
